import { Flow } from 'signup-constants/Flow';
import { BIAB001RemoveSteps } from '../experiments/biab001/biab001RemoveSteps';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchMoveVerificationStepsACQ124 } from './branches/BranchMoveVerificationStepsACQ124';
import { BranchOnePageSignupACQ126 } from './branches/BranchOnePageSignupACQ126';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { BranchUseCase } from './branches/BranchUseCase';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
const DefaultBranches = [BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber, BranchMoveVerificationStepsACQ124, BranchOnePageSignupACQ126];
export const FlowBranches = {
  [Flow.Crm]: [BranchUseCase, BIAB001RemoveSteps, ...softwareSignupBranches],
  [Flow.Marketing]: softwareSignupBranches,
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch],
  [Flow.Service]: softwareSignupBranches,
  [Flow.CmsFree]: softwareSignupBranches
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};